import { css, cx } from "@emotion/css"
import { ReactNode } from "react"

export function TableTitle({ title }: { title: string | ReactNode }) {
  return <div className={cx("HeadingH5bBold", styles.root)}>{title}</div>
}

const styles = {
  root: css`
    color: var(--white);
    margin-bottom: 20px;
  `,
}
